import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ERegionsComponent } from '../../components/manage-eregions/manage-eregions.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PostcodeMapsModule } from './postcode-maps.module';

const routes: Routes = [
  { path: '', component: ERegionsComponent, data: { title: 'Manage Engineius Regions' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ERegionsRoutingModule {}

@NgModule({
  imports: [
    ERegionsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    PostcodeMapsModule,
  ],
  declarations: [ERegionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ERegionsModule {}
